import React from "react";
import RadioButton from "./RadioButton";

const RadioSelection = ({
  label,
  divClassName,
  mapClass,
  internalDivClass,
  secondRadioClass,
  textClass,
  name,
  value,
  error,
  touched,
  setFieldValue,
  options,
  withContent,
  makeHotFeatured,
}) => {
  return (
    <div className={divClassName}>
      <p className="lg:text-[16px] sm:text-[14px] font-[500] text-[#303030] mb-3 font-poppins text-start">
        {label}
      </p>
      {withContent ? (
        <div className={mapClass}>
          {options?.map((op, index) => (
            <div key={index} className={internalDivClass}>
              <div
                className={`flex items-center ${index > 0 ? secondRadioClass : ""}`}
              >
                <RadioButton
                  divClassName="flex items-start"
                  text={op?.title}
                  checked={value === op?.value}
                  onChecked={() => {
                    setFieldValue(name, op?.value);
                  }}
                  textClass={textClass}
                  content={op?.content}
                  contentClass={
                    "font-[400] text-[14px] text-[#767676] ml-4"
                  }
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={mapClass}>
          {options?.map((op, index) => (
            <div key={index} className={internalDivClass}>
              <div
                className={`flex items-center ${index > 0 ? secondRadioClass : ""}`}
              >
                <RadioButton
                  divClassName="flex items-start"
                  text={op}
                  checked={value === op}
                  onChecked={() => {
                    setFieldValue(name, op);
                    if (makeHotFeatured !== undefined) {
                      console.log('first condition', op)
                      makeHotFeatured(op);
                    }
                  }}
                  textClass={textClass}
                />
              </div>
            </div>
          ))}
        </div>
      )}
      {error && touched ? (
        <div className="ms-1">
          <span className="text-red-600 sm:text-[10px] md:text-[12px] font-[600] text-start">
            {error}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default RadioSelection;
